module.exports = __webpack_public_path__ + "static/media/book-solid.9848a002.svg";